import axios from "axios";

// ✅ REMOVED: TOKEN_KEY (token now in HttpOnly cookie, not accessible to JS)
export const USER_KEY = "auth_user";
export const ROLE_ID_KEY = "auth_role_id";
export const PERMISSIONS_KEY = "auth_permissions";

let redirectingToLogin = false;

// ✅ REMOVED: getStoredToken() - token in HttpOnly cookie, not accessible

export const clearStoredSession = () => {
  try {
    // ✅ REMOVED: localStorage.removeItem(TOKEN_KEY) - token now server-managed
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(ROLE_ID_KEY);
    localStorage.removeItem(PERMISSIONS_KEY);
  } catch (e) {}
};

export const redirectToLogin = () => {
  if (redirectingToLogin || window.location.pathname === "/login") return;
  redirectingToLogin = true;
  clearStoredSession();
  setTimeout(() => {
    window.location.href = "/login";
    redirectingToLogin = false;
  }, 100);
};

// ✅ REMOVED: attachAuthHeader() - not needed, cookies sent automatically

export const createApiClient = (config = {}) => {
  const client = axios.create({
    ...config,
    // ✅ CRITICAL: Enable cookie sending for Axios
    withCredentials: true
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        redirectToLogin();
      }
      return Promise.reject(error);
    }
  );

  return client;
};

export const authFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    // ✅ CRITICAL: Enable cookie sending for Fetch API
    credentials: 'include',
    headers: options.headers || {},
  });

  if (response.status === 401) {
    redirectToLogin();
  }

  return response;
};

export const publicFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',  // ✅ Also include cookies for consistency
    headers: options.headers || {},
  });

  return response;
};

// ✅ UPDATE: Global axios configuration to support credentials (cookies)
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);
